module.exports = __webpack_public_path__ + "img/produto-modal.c6694a28.svg";